import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=12f4b828"
import script from "./SelectArea.vue?vue&type=script&lang=js"
export * from "./SelectArea.vue?vue&type=script&lang=js"
import style0 from "./SelectArea.vue?vue&type=style&index=0&id=12f4b828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports